import React from 'react';

function ICIntegrationRestrict() {
  return <div>This website is restricted to ice-users ldap group only.</div>;
}

ICIntegrationRestrict.propTypes = {};

ICIntegrationRestrict.defaultProps = {};

export default ICIntegrationRestrict;
